import { setI18nLocale } from '@/locales/i18n';
import { defineStore } from 'pinia';
import type { ComputedRef} from 'vue';
import { computed, ref } from 'vue';

export interface LocaleInterface {
  locale: ComputedRef<string>;
  setLocale: (locale: string) => void;
}

const LOCALES = ['en', 'zh', 'tr'];

const getLocale = () => {
  const navigatorLanguage = navigator.language.split('-')[0];

  return localStorage.getItem('locale')
    ? localStorage.getItem('locale')!
    : LOCALES.includes(navigatorLanguage)
    ? navigatorLanguage
    : 'en';
};

export const useLocaleStore = defineStore<'locale', LocaleInterface>(
  'locale',
  () => {
    const _locale = ref(getLocale());
    const locale = computed(() => _locale.value);

    const setLocale = (locale: string) => {
      if (LOCALES.includes(locale)) {
        localStorage.setItem('locale', String(locale));
        _locale.value = locale;

        setI18nLocale(locale);
      }
    };

    return {
      locale,
      setLocale
    };
  }
);